/**
 * EBH 2026-09-14 — substituição nativa do Selleasy (ficha de produto + gaveta
 * do carrinho). Ver theme_fixes/selleasy_nativo_2026-09-14/.
 *
 * Ficheiro à parte, não integrado no bundle theme.min.js: o tema não expõe as
 * suas funções internas de carrinho/carrossel em `window`, por isso este
 * ficheiro fala só com o que É público — os endpoints /cart/*.js do Shopify,
 * o evento de DOM "apps:product-added-to-cart" (o mesmo que o quick-cart já
 * escuta para se atualizar) e o ícone do carrinho no cabeçalho (para o abrir).
 * Não carrega biblioteca nenhuma: o carrossel da gaveta foi substituído por
 * uma lista simples a 2026-09-15, e com ele saiu a dependência do Swiper.
 *
 * Delegação de eventos em document: a gaveta do carrinho substitui o seu
 * próprio innerHTML de cada vez que se atualiza (refreshQuickCart), por isso
 * um listener preso a um elemento concreto perder-se-ia — delegar em
 * document sobrevive a isso sem precisar de saber quando o carrinho mudou.
 */
(function () {
  "use strict";

  var CART_ICON_SELECTOR = "[data-js-cart-icon=\"cart\"]";

  // Os formatos de dinheiro da Shopify não são só {{amount}}. Até 17/09 só se
  // substituía esse, e nos mercados em coroa/zloty/euro com vírgula o carrinho
  // escrevia «{{amount_with_comma_separator}} kr» ao cliente, sem erro nenhum.
  var FORMATOS_DINHEIRO = {
    amount: [2, ",", "."],
    amount_no_decimals: [0, ",", "."],
    amount_with_comma_separator: [2, ".", ","],
    amount_no_decimals_with_comma_separator: [0, ".", ","],
    amount_with_apostrophe_separator: [2, "'", "."],
    amount_no_decimals_with_space_separator: [0, " ", ","],
    amount_with_space_separator: [2, " ", ","],
    amount_with_period_and_space_separator: [2, " ", "."]
  };

  function comSeparadores(cents, casas, milhares, decimal) {
    var partes = (cents / 100).toFixed(casas).split(".");
    var inteiros = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, milhares);
    return partes[1] ? inteiros + decimal + partes[1] : inteiros;
  }

  function money(cents) {
    var formato = (window.theme && window.theme.moneyFormat) || "{{amount}}";
    return formato.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, nome) {
      var regra = FORMATOS_DINHEIRO[nome] || FORMATOS_DINHEIRO.amount;
      return comSeparadores(cents, regra[0], regra[1], regra[2]);
    });
  }

  function notifyCartUpdated() {
    document.dispatchEvent(new CustomEvent("apps:product-added-to-cart"));
  }

  // ── A/B de uma peça (2026-09-23, Melting Ice Cream) ─────────────────────────
  // O widget desenha DUAS alternativas (Bowl 13 = A · Cone Bowl = B, tiles com
  // data-ebh-ab); mostra-se só a do balde deste browser, 50/50 pelo id estável
  // `ebh:wl:bid` (o mesmo dos favoritos — um id só, sem nada pessoal). A outra
  // sai do cesto (desmarcada + desativada, para não entrar no total nem no "Levar
  // tudo") e fica escondida por CSS. O braço mostrado vai no beacon → o painel
  // mede qual bowl converte. Sem tiles A/B isto não faz nada.
  function bidLocal() {
    try {
      if (window.EBHWishlist && typeof window.EBHWishlist.bid === "function") return window.EBHWishlist.bid();
      var v = window.localStorage.getItem("ebh:wl:bid");
      if (v) return v;
      v = "b" + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
      window.localStorage.setItem("ebh:wl:bid", v);
      return v;
    } catch (e) { return "b0"; }
  }

  function bracoAB() {
    var s = bidLocal(), h = 0, i;
    for (i = 0; i < s.length; i += 1) h = (h * 31 + s.charCodeAt(i)) >>> 0;
    return (h % 2) === 0 ? "A" : "B";
  }

  function aplicarAB(root) {
    var arm = bracoAB();
    root.querySelectorAll("[data-ebh-bundle]").forEach(function (widget) {
      var abs = Array.prototype.slice.call(widget.querySelectorAll("[data-ebh-ab]"));
      if (!abs.length) return;
      // o braço deste browser; se essa alternativa não foi desenhada (esgotada),
      // mostra-se a que houver — nunca deixar o pacote sem bowl.
      var escolhido = abs.filter(function (t) { return t.getAttribute("data-ebh-ab") === arm; })[0] || abs[0];
      widget.dataset.ebhAb = escolhido.getAttribute("data-ebh-ab");
      abs.forEach(function (tile) {
        var mostrar = tile === escolhido;
        tile.classList.toggle("is-ab-shown", mostrar);
        var box = tile.querySelector("[data-ebh-bundle-checkbox]");
        if (box) { box.checked = mostrar; box.disabled = !mostrar; }
      });
    });
  }

  function openCartDrawer() {
    var icon = document.querySelector(CART_ICON_SELECTOR);
    if (icon) icon.click();
  }

  // ── analytics (2026-09-14) — ver ebh-spine/src/index.js, xsellEvento/xsellAnalytics.
  // Views/cliques só interessam para o painel interno; nunca bloqueiam nada do
  // que o cliente está a fazer, por isso sendBeacon (sobrevive a navegação) com
  // fallback silencioso em fetch — uma falha aqui não aparece a ninguém.
  function beacon(tipo, el) {
    var grupo = el && el.dataset ? el.dataset.ebhBundleGrupo : "";
    if (!grupo) return;
    // O modo diz a superfície: 'builder' é a ficha de produto, 'carousel' o
    // carrinho. Sem isto as duas somavam-se numa só e não se podia comparar
    // qual é que converte — que é a pergunta mais útil que estes números têm
    // para dar (ver ebh-spine/src/index.js, xsellEvento).
    var payload = JSON.stringify({
      tipo: tipo,
      grupo: grupo,
      produto_gatilho: el.dataset.ebhBundleProduto || "",
      modo: el.dataset.ebhBundleMode || "",
      // 2026-09-23 — o braço do A/B mostrado ('A'/'B'), vazio quando o widget não
      // tem A/B. É por aqui que o painel mede qual bowl converte melhor.
      ab: el.dataset.ebhAb || ""
    });
    if (navigator.sendBeacon) {
      navigator.sendBeacon("/apps/ebh/xsell", new Blob([payload], { type: "application/json" }));
      return;
    }
    fetch("/apps/ebh/xsell", {
      method: "POST", credentials: "same-origin", keepalive: true,
      headers: { "Content-Type": "application/json" },
      body: payload
    }).catch(function () {});
  }

  // Uma "visualização" é o widget APARECER no ecrã, não existir no HTML.
  // Na página /cart há sempre dois: o da página e o da gaveta fechada, que
  // vive fora do ecrã à direita — contar os dois no arranque duplicava as
  // views dessa página (visto a 2026-09-15). Com IntersectionObserver só
  // conta quem entra mesmo no campo de visão, que é também o que a app
  // antiga media.
  var viewedWidgets = new WeakSet();
  var viewObserver = null;

  function marcarVisto(el) {
    if (viewedWidgets.has(el)) return;
    viewedWidgets.add(el);
    beacon("view", el);
  }

  function trackViews(root) {
    var nodes = root.querySelectorAll("[data-ebh-bundle]");
    if (!nodes.length) return;

    if (!("IntersectionObserver" in window)) {
      nodes.forEach(marcarVisto);
      return;
    }

    if (!viewObserver) {
      viewObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            marcarVisto(entry.target);
            viewObserver.unobserve(entry.target);
          });
        },
        { threshold: 0.25 }
      );
    }

    nodes.forEach(function (el) {
      if (!viewedWidgets.has(el)) viewObserver.observe(el);
    });
  }

  function addItems(items) {
    return fetch("/cart/add.js", {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      return res.json();
    });
  }

  // ── ficha de produto: total dinâmico + botão "Add bundle to cart" ──────

  // A barra mostra os três números: quanto fica a pagar, quanto era antes
  // (riscado) e quanto se poupa. Só a poupança não chegava — no momento de
  // decidir falta o preço final (15/09).
  function updateBundleTotal(builder) {
    var was = 0;
    var now = 0;

    // 2026-09-24 — a escada do pacote: com 2 ou mais companheiras marcadas a
    // percentagem delas passa de pct para pct2 (as canecas Breeze: 10 → 20).
    // O Liquid pinta os cartões a pct; é aqui que os preços dos cartões e o
    // total mudam ao marcar/desmarcar. O gatilho nunca entra na escada.
    // 2026-09-23 — TRÊS degraus (Melting Ice Cream: 10/15/20): a % sobe com
    // quantas companheiras estão marcadas. Sem pct3 (Breeze) fica em dois.
    var pct2 = parseFloat(builder.dataset.ebhBundlePct2);
    var pct3 = parseFloat(builder.dataset.ebhBundlePct3);
    var marcadas = builder.querySelectorAll("[data-ebh-bundle-checkbox]:checked");
    var pctEscada = 0;
    if (pct3 > 0 && marcadas.length >= 3) pctEscada = pct3;
    else if (pct2 > 0 && marcadas.length >= 2) pctEscada = pct2;

    function somar(el, companheira) {
      var price = parseInt(el.dataset.price, 10) || 0;
      var sale = parseInt(el.dataset.salePrice, 10) || 0;
      if (companheira && pctEscada) sale = Math.round(price * (100 - pctEscada) / 100);
      was += price;
      now += sale;
      return sale;
    }

    var triggerPrice = builder.querySelector("[data-ebh-bundle-price]");
    if (triggerPrice) somar(triggerPrice, false);
    builder.querySelectorAll("[data-ebh-bundle-checkbox]").forEach(function (box) {
      var row = box.closest("[data-ebh-bundle-row]");
      var etiqueta = row && row.querySelector(".ebh-bundle__price-sale");
      var price = parseInt(box.dataset.price, 10) || 0;
      var base = parseInt(box.dataset.salePrice, 10) || 0;
      var sale = box.checked ? somar(box, true) : (pctEscada ? Math.round(price * (100 - pctEscada) / 100) : base);
      if (etiqueta && (pct2 > 0 || pct3 > 0)) etiqueta.innerHTML = money(sale);
    });

    // innerHTML de propósito: theme.moneyFormat costuma vir com a marcação
    // <span class="money">...</span> à volta — com textContent essas tags
    // apareciam escritas por extenso no ecrã em vez de desaparecerem (bug
    // visto ao vivo a 2026-09-15). O valor é sempre nosso (money(), nunca
    // texto de fora), por isso não há risco de XSS aqui.
    function escrever(seletor, cents) {
      var el = builder.querySelector(seletor);
      if (el) el.innerHTML = money(cents);
    }

    escrever("[data-ebh-bundle-now]", now);
    escrever("[data-ebh-bundle-was]", was);
    escrever("[data-ebh-bundle-total]", was - now);
  }

  // Desde 15/09 os companheiros nascem MARCADOS (opt-out — ver o comentário
  // em ebh-bundle-products.liquid). O Liquid já pinta a poupança certa à
  // primeira, mas o browser pode repor caixas desmarcadas ao voltar atrás
  // (bfcache), e aí o número no ecrã ficaria a mentir até alguém mexer.
  // Desde 15/09 o carrinho usa o mesmo mecanismo da ficha (peças marcadas +
  // um só botão), por isso nada disto olha ao `mode`: vale em qualquer
  // widget que tenha total para atualizar.
  function syncBundleTotals(root) {
    root.querySelectorAll("[data-ebh-bundle]").forEach(function (el) {
      if (el.querySelector("[data-ebh-bundle-total]")) updateBundleTotal(el);
    });
  }

  document.addEventListener("change", function (event) {
    var checkbox = event.target.closest("[data-ebh-bundle-checkbox]");
    if (!checkbox) return;
    var widget = checkbox.closest("[data-ebh-bundle]");
    if (!widget) return;
    updateBundleTotal(widget);
    if (checkbox.checked) beacon("click", widget);
  });

  document.addEventListener("click", function (event) {
    var addButton = event.target.closest("[data-ebh-bundle-add]");
    if (!addButton) return;
    event.preventDefault();

    var builder = addButton.closest("[data-ebh-bundle]");
    if (!builder || addButton.classList.contains("is-loading")) return;

    // Na ficha, o produto-âncora entra no carrinho com os companheiros. No
    // carrinho já lá está, e o botão vem sem `data-trigger-variant-id` — daí
    // a lista começar vazia em vez de começar com ele.
    var items = [];
    var triggerId = parseInt(addButton.dataset.triggerVariantId, 10);
    if (triggerId) items.push({ id: triggerId, quantity: 1 });

    builder.querySelectorAll("[data-ebh-bundle-checkbox]:checked").forEach(function (box) {
      items.push({ id: parseInt(box.value, 10), quantity: 1 });
    });
    if (!items.length) return;

    addButton.classList.add("is-loading");
    beacon("click", builder);
    // Na PÁGINA do carrinho a lista de artigos é servida pelo servidor: sem
    // recarregar, a peça entrava no carrinho mas a página continuava a
    // mostrar o carrinho antigo. Na gaveta não é preciso — ela sabe
    // atualizar-se sozinha com o evento.
    var naPaginaDoCarrinho = !!builder.closest(".ebh-bundle--page");
    var naGaveta = !!builder.closest(".quick-cart");

    addItems(items)
      .then(function () {
        if (naPaginaDoCarrinho) {
          window.location.reload();
          return;
        }
        notifyCartUpdated();
        if (!naGaveta) openCartDrawer();
      })
      .finally(function () {
        addButton.classList.remove("is-loading");
      });
  });

  // 2026-09-15: o Swiper saiu daqui. A gaveta passou a mostrar uma lista de
  // 2 linhas (ver ebh-bundle-products.liquid) — não há o que deslizar, e as
  // setas do carrossel apareciam empilhadas no fundo da gaveta.

  // 2026-09-24 — o pacote é da VARIANTE (a Cat Mom amarela oferece a Cat Dad
  // amarela). Quando a pessoa muda de cor na ficha, o tema não refaz a nossa
  // secção — pede-se o HTML da secção outra vez com `?variant=` (Section
  // Rendering API) e troca-se o widget. Ouve-se o evento do tema
  // (`product:variant-change`, só quando o tema o emite) E o `change` do
  // campo `name="id"` do formulário, que existe sempre.
  var refazerTimer = null;
  function refazerPorVariante(variantId) {
    if (!variantId) return;
    clearTimeout(refazerTimer);
    refazerTimer = setTimeout(function () {
      document.querySelectorAll("[data-ebh-bundle][data-ebh-bundle-section]").forEach(function (el) {
        if (el.dataset.ebhBundleMode !== "builder") return;
        if (String(el.dataset.ebhBundleVariant) === String(variantId)) return;
        var sec = el.dataset.ebhBundleSection;
        if (!sec) return;
        var url = window.location.pathname.split("?")[0] + "?variant=" + encodeURIComponent(variantId) + "&section_id=" + encodeURIComponent(sec);
        fetch(url, { credentials: "same-origin" }).then(function (r) { return r.ok ? r.text() : ""; }).then(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, "text/html");
          var novo = doc.querySelector("[data-ebh-bundle]");
          var actual = document.querySelector("[data-ebh-bundle][data-ebh-bundle-section=\"" + sec + "\"]");
          if (!actual) return;
          if (!novo) { actual.remove(); return; }
          actual.replaceWith(novo);
          aplicarAB(document); syncBundleTotals(document); trackViews(document);
        }).catch(function () {});
      });
    }, 150);
  }
  document.addEventListener("product:variant-change", function (e) {
    var v = e && e.detail && e.detail.variant; if (v && v.id) refazerPorVariante(v.id);
  });
  document.addEventListener("change", function (e) {
    var campo = e.target && e.target.closest && e.target.closest("form[action*=\"/cart/add\"] [name=\"id\"]");
    if (campo && campo.value) refazerPorVariante(campo.value);
  });

  document.addEventListener("DOMContentLoaded", function () {
    aplicarAB(document);
    trackViews(document);
    syncBundleTotals(document);
  });

  window.addEventListener("pageshow", function () {
    aplicarAB(document);
    syncBundleTotals(document);
  });

  // A gaveta do carrinho substitui `.quick-cart__items` inteiro sempre que se
  // atualiza (ver refreshQuickCart em theme.min.js) — por isso uma lista nova
  // (e uma view nova) pode aparecer sem nenhum evento de DOM "carregado" a avisar.
  var quickCartItems = document.querySelector(".quick-cart__items");
  if (quickCartItems && "MutationObserver" in window) {
    new MutationObserver(function () {
      aplicarAB(quickCartItems);
      trackViews(quickCartItems);
    }).observe(quickCartItems, { childList: true, subtree: false });
  }

  aplicarAB(document);
  trackViews(document);
  syncBundleTotals(document);
})();
